export enum SurroundingSkinColorEnum {
  Normal = 1,
  Red = 2,
  Pale = 3,
  Black = 4,
  Purple = 5,
  Other = 99
}

export const SurroundingSkinColorOptions = [
{ id: 1, label: 'None' },
{ id: 2, label: 'Slight' },
{ id: 3, label: 'Moderate' },
{ id: 4, label: 'Black' },
{ id: 5, label: 'Purple' },
{ id: 99, label: 'Other' }
];
